import { Action } from 'typescript-fsa';
import * as actions from './actions';
import { Dispatch } from 'redux';
import { inferenceSubdiv, uploadImage } from '../../../apis';
import { loadingOperations } from '../loading';
import { getLogger } from '../../../utils';
import { systemStateMessageOperations } from '..';
import { Storage } from 'aws-amplify';


const getSignedUrl = async (params: { bucket: string; key: string;}) => {
  return Storage.vault.get(params.key,
    {
      bucket: params.bucket,
      level: 'public',
      customPrefix: {
        public: ''
      }
    });
};

const execute = ({ koujiBangou, inferenceId, imageStr, contentType }
      : { koujiBangou: string, inferenceId: string, imageStr: string, contentType: string}) => async (dispatch: Dispatch<Action<any>>) => {
  loadingOperations.startLoading()(dispatch);

  try {
    // 拡張子をcontentTypeから取得する
    const ext = contentType.toLowerCase().endsWith('png')
            ? 'png'
            : 'jpeg'
    // ファイル名生成
    const key = `${inferenceId}-cropped.${ext}`;
    await uploadImage({ key, imageStr, contentType });
    const inferenceResult = await inferenceSubdiv({
      koujiBangou,
      inferenceId,
      imagePath: `s3://${process.env.REACT_APP_IMAGEUPLOADBUCKETNAME}/${key}`
    });
    const croppedImage = {
      bucket: process.env.REACT_APP_IMAGEUPLOADBUCKETNAME || '',
      key
    };
    await Promise.all(inferenceResult.results.map(
      async (item) => {
        const url = await getSignedUrl({ key: item.overlay_img_key, bucket: item.overlay_img_bucket });
        item.overlay_img_presigned_url = url as string;
      }
    ));
    dispatch(actions.execute.done({
      params: { imageStr },
      result: {
        results: inferenceResult.results,
        additionalResult: inferenceResult.additionalResult,
        coordinatesResults: inferenceResult.coordinatesResults,
        croppedImage
      }
    }));
  } catch (error) {
    dispatch(actions.execute.failed({ params: { imageStr }, error: error.toString() }))
    getLogger().error('inferenceSubdiv/execute()', error);
    systemStateMessageOperations.putError({ message: '通信エラーが発生しました。' })(dispatch);
  } finally {
    loadingOperations.stopLoading()(dispatch);
  }
}

const reset = () => async (dispatch: Dispatch<Action<any>>) => {
  dispatch(actions.reset());
};

export {
  execute,
  reset
};



// WEBPACK FOOTER //
// ./src/redux/modules/inferenceSubdiv/operations.ts